// Generado por `node services/sandbox/dist/cli/seed-qr.js` (T-INT-05). No editar a mano.
/** QR Bre-B de los comercios ficticios del demo (`@paguz/breb-qr`). */
export interface DemoQr {
  readonly file: string;
  readonly name: string;
  readonly city: string;
  readonly keyLabel: string;
  readonly kind: 'STATIC' | 'DYNAMIC';
  readonly amount: string | null;
  readonly payload: string;
}

export const DEMO_QRS: readonly DemoQr[] = [
  {
    file: 'ferreteria-don-pedro-180000.png',
    name: 'Ferretería Don Pedro',
    city: 'Bogotá',
    keyLabel: 'Celular 310 555 0101',
    kind: 'DYNAMIC',
    amount: '180000.00',
    payload:
      '00020101021226440013CO.BREB.PAGOS0103CEL021031055501010302075204525153031705409180000.005802CO5920Ferreteria Don Pedro6006Bogota62130509DEMO-ESC164400002ES0120Ferretería Don Pedro0206Bogotá63048385',
  },
  {
    file: 'ferreteria-don-pedro.png',
    name: 'Ferretería Don Pedro',
    city: 'Bogotá',
    keyLabel: 'Celular 310 555 0101',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126440013CO.BREB.PAGOS0103CEL021031055501010302075204525153031705802CO5920Ferreteria Don Pedro6006Bogota64400002ES0120Ferretería Don Pedro0206Bogotá63048C20',
  },
  {
    file: 'distribuidora-el-mayorista-del-sur.png',
    name: 'Distribuidora El Mayorista del Sur',
    city: 'Bogotá',
    keyLabel: 'Llave @mayoristadelsur',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126520013CO.BREB.PAGOS0105ALIAS0216@mayoristadelsur0302515204541153031705802CO5934Distribuidora El Mayorista del Sur6006Bogota64540002ES0134Distribuidora El Mayorista del Sur0206Bogotá63048C4C',
  },
  {
    file: 'lacteos-san-isidro.png',
    name: 'Lácteos San Isidro',
    city: 'Bogotá',
    keyLabel: 'Llave @lacteossanisidro',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126530013CO.BREB.PAGOS0105ALIAS0217@lacteossanisidro0302835204545153031705802CO5918Lacteos San Isidro6006Bogota64380002ES0118Lácteos San Isidro0206Bogotá63047DCF',
  },
  {
    file: 'granos-y-abarrotes-la-cosecha.png',
    name: 'Granos y Abarrotes La Cosecha',
    city: 'Bogotá',
    keyLabel: 'Código de comercio 0012345',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126410013CO.BREB.PAGOS0103COM020700123450302015204541153031705802CO5929Granos y Abarrotes La Cosecha6006Bogota64490002ES0129Granos y Abarrotes La Cosecha0206Bogotá63042C4B',
  },
  {
    file: 'empaques-plasticos-andina.png',
    name: 'Empaques Plásticos Andina',
    city: 'Bogotá',
    keyLabel: 'NIT 900.123.456',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126430013CO.BREB.PAGOS0103DOC02099001234560302075204508553031705802CO5925Empaques Plasticos Andina6006Bogota64450002ES0125Empaques Plásticos Andina0206Bogotá6304D600',
  },
  {
    file: 'carnes-frias-el-llanero.png',
    name: 'Carnes Frías El Llanero',
    city: 'Bogotá',
    keyLabel: 'Llave @elllanero',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126460013CO.BREB.PAGOS0105ALIAS0210@elllanero0302135204542253031705802CO5923Carnes Frias El Llanero6006Bogota64430002ES0123Carnes Frías El Llanero0206Bogotá630434DE',
  },
  {
    file: 'repuestos-moto-express.png',
    name: 'Repuestos Moto Express',
    city: 'Soacha',
    keyLabel: 'Celular 315 666 0202',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126440013CO.BREB.PAGOS0103CEL021031566602020302515204501353031705802CO5922Repuestos Moto Express6006Soacha6304EFE5',
  },
  {
    file: 'harinas-y-levaduras-del-valle.png',
    name: 'Harinas y Levaduras del Valle',
    city: 'Medellín',
    keyLabel: 'Llave @harinasdelvalle',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126520013CO.BREB.PAGOS0105ALIAS0216@harinasdelvalle0302015204549953031705802CO5929Harinas y Levaduras del Valle6008Medellin64510002ES0129Harinas y Levaduras del Valle0208Medellín63048AB1',
  },
  {
    file: 'papeleria-arcoiris.png',
    name: 'Papelería Arcoíris',
    city: 'Bogotá',
    keyLabel: 'Llave @papeleriaarcoiris',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126560013CO.BREB.PAGOS0105ALIAS0218@papeleriaarcoiris030415075204594353031705802CO5918Papeleria Arcoiris6006Bogota64380002ES0118Papelería Arcoíris0206Bogotá6304947B',
  },
  {
    file: 'verduras-dona-chela.png',
    name: 'Verduras Doña Chela',
    city: 'Bogotá',
    keyLabel: 'Llave @verdurasdonachela',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126540013CO.BREB.PAGOS0105ALIAS0218@verdurasdonachela0302915204549953031705802CO5919Verduras Dona Chela6006Bogota64390002ES0119Verduras Doña Chela0206Bogotá63040F51',
  },
  {
    file: 'gaseosas-y-refrescos-el-oasis.png',
    name: 'Gaseosas y Refrescos El Oasis',
    city: 'Cali',
    keyLabel: 'Llave @eloasis',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126440013CO.BREB.PAGOS0105ALIAS0208@eloasis0302235204541153031705802CO5929Gaseosas y Refrescos El Oasis6004Cali63046473',
  },
  {
    file: 'drogueria-vida-sana.png',
    name: 'Droguería Vida Sana',
    city: 'Medellín',
    keyLabel: 'Llave @drogueriavidasana',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126540013CO.BREB.PAGOS0105ALIAS0218@drogueriavidasana0302525204591253031705802CO5919Drogueria Vida Sana6008Medellin64410002ES0119Droguería Vida Sana0208Medellín6304CC3F',
  },
  {
    file: 'cacharreria-la-economica.png',
    name: 'Cacharrería La Económica',
    city: 'Bucaramanga',
    keyLabel: 'Llave @laeconomica',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126480013CO.BREB.PAGOS0105ALIAS0212@laeconomica0302325204533153031705802CO5924Cacharreria La Economica6011Bucaramanga64490002ES0124Cacharrería La Económica0211Bucaramanga63048AE3',
  },
  {
    file: 'panificadora-central.png',
    name: 'Panificadora Central',
    city: 'Medellín',
    keyLabel: 'Llave @panificadoracentral',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126560013CO.BREB.PAGOS0105ALIAS0220@panificadoracentral0302405204546253031705802CO5920Panificadora Central6008Medellin64420002ES0120Panificadora Central0208Medellín6304EC9B',
  },
  {
    file: 'plasticos-el-sol.png',
    name: 'Plásticos El Sol',
    city: 'Cali',
    keyLabel: 'Llave @plasticoselsol',
    kind: 'STATIC',
    amount: null,
    payload:
      '00020101021126510013CO.BREB.PAGOS0105ALIAS0215@plasticoselsol0302075204508553031705802CO5916Plasticos El Sol6004Cali64340002ES0116Plásticos El Sol0204Cali63044FD2',
  },
];

/** URL del PNG de un QR (Vite resuelve el asset). */
export const qrImageUrl = (file: string): string => new URL(`./qr/${file}`, import.meta.url).href;

/** URL del PDF imprimible (4 QR por página A4). */
export const qrSheetUrl = (): string => new URL('./qr/comercios-qr.pdf', import.meta.url).href;
